/**
 * กฎระบบร้านค้าตั้งแผงของผู้เล่น (Player Vending)
 *
 * ตาม GDD หัวข้อ 6 & 8:
 * - ตั้งร้านได้ในลานตลาดเมือง Wickhaven (โซน meadow ใจกลางเมือง)
 * - ตั้งชื่อร้าน ไอเทม และราคาขายต่อชิ้นเองได้สูงสุด 8 รายการ
 * - หักภาษีตลาด 3% จากยอดขาย (Gold sink)
 */
export const VENDING_MAX_ITEMS = 8;
export const VENDING_TITLE_MAX_LEN = 30;
export const MARKET_TAX_RATE = 0.03;
/** ระยะจากใจกลางเมือง (0, 0) ที่อนุญาตให้ตั้งร้านได้ (หน่วยโลก) */
export const VENDING_ZONE_RADIUS = 25;
export const VENDING_DENIAL_TEXT = {
    "not-town": "ตั้งร้านได้เฉพาะในเมือง Wickhaven เท่านั้น",
    "far-market": "ต้องตั้งร้านในบริเวณลานตลาดกลางเมือง",
    dead: "ไม่สามารถตั้งร้านขณะหมดสติ",
    trading: "ไม่สามารถตั้งร้านขณะกำลังแลกเปลี่ยน",
    "invalid-title": "ชื่อร้านต้องมีความยาว 1-30 ตัวอักษร",
    "no-items": "ต้องมีไอเทมวางขายอย่างน้อย 1 ชิ้น",
    "too-many": `วางขายได้สูงสุด ${VENDING_MAX_ITEMS} รายการ`,
    "no-item-have": "มีไอเทมไม่เพียงพอตามที่ต้องการวางขาย",
    "invalid-price": "ราคาไอเทมต้องมากกว่า 0",
    "not-found": "ไม่พบร้านค้านี้หรือร้านปิดไปแล้ว",
    "no-gold": "มีโกลด์ไม่เพียงพอสำหรับซื้อสินค้านี้",
    "weight-exceeded": "น้ำหนักกระเป๋าของคุณจะเกินขีดจำกัดหากซื้อสินค้านี้",
    closed: "ร้านค้านี้ปิดแล้ว",
};
/** คำนวณเงินที่ผู้ขายได้รับหลังหักภาษีตลาด 3% */
export function calculateVendingPayout(totalPrice) {
    const tax = Math.floor(totalPrice * MARKET_TAX_RATE);
    return {
        tax,
        payout: totalPrice - tax,
    };
}
//# sourceMappingURL=vending.js.map